import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";

//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

//Actions
import {
    manufacturersRefreshFirmwareRequest,
    clearRedux,
} from 'Redux/actions';

const RefreshFirmwares = (props) => {
    const { tableRef } = props;
    const dispatch = useDispatch();
    const { messages } = useIntl();

    const { loading, openModal, result } = useSelector(state => state.refreshFirmwareRedux);

    const closeModal = () => {
        dispatch(clearRedux("MANUFACTURER_REFRESH_FIRMWARE"));
    }

    const refresh = () => {
        dispatch(manufacturersRefreshFirmwareRequest());
    }

    useEffect(() => {
        if (result?.refresh) {
            tableRef && tableRef?.current?.getData();
            NotificationManager.success(
                messages['refresh_firmware_success_message'],
                messages['refresh_firmware_title'],
                3000
            );
            closeModal();
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={messages['refresh_firmware_title']}
            loading={loading}
            position="right"
            size="small"
            handleClose={closeModal}
        >
            <ModalBody>
                <div style={{ padding: '0 10px' }}>
                    <label style={{ marginBottom: 5 }}>
                        {messages['refresh_firmware_question']}
                    </label>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => refresh()}
                >
                    {messages['refresh_firmware_refresh']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default RefreshFirmwares;